module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Street":"Straße u. Hausnummer","ZipCode":"PLZ","Town":"Stadt","Rules":{"Required":"Pflichtfeld","Max":"Maximal %{maxLength} Zeichen"}},"en":{"Street":"Street and number","ZipCode":"Zip","Town":"Town","Rules":{"Required":"Required","Max":"No more than %{maxLength} characters"}}}')
  delete Component.options._Ctor
}
